import { useRef, useLayoutEffect, useContext } from 'react'
import useMeasure from 'react-use-measure'
import gsap from 'gsap'
import { createUseStyles } from 'react-jss'
import { Context as ScrollbarContext } from '@/context/scrollbar'

import style from './style'

const useStyles = createUseStyles(style)

const SingleAccordion = ({ children, title, active, setActive }) => {
  const classes = useStyles()
  const $animatedWrapper = useRef(null)
  const $arrow = useRef()
  const [$measureRef, bounds] = useMeasure()

  const { scrollbar } = useContext(ScrollbarContext)

  useLayoutEffect(() => {
    if (!$animatedWrapper.current) return
    gsap.context(() => {
      gsap.to($animatedWrapper.current, {
        height: active ? bounds.height : 0,
        opacity: active ? 1 : 0,
        ease: 'power3.out',
        duration: 0.7,
        onUpdate: () => {
          if (!scrollbar) return
          scrollbar.update()
        },
      })
      gsap.to($arrow.current, {
        rotation: active ? '-90deg' : '90deg',
        ease: 'power3.out',
        duration: 0.7,
      })
    }, [$animatedWrapper])
  }, [$animatedWrapper, active, bounds, scrollbar])

  return (
    <div className={classes.root}>
      <div
        className={classes.accordionButton}
        onClick={() => setActive(!active)}
        role="presentation"
      >
        <h6 className={classes.accordionTitle}>
          {title}
        </h6>
        <div
          ref={$arrow}
          className={classes.arrow}
        >
          <svg>
            <use xlinkHref="#ico-arrow-right2" />
          </svg>
        </div>
        {/* <ArrowButton className={classes.arrow} ref={$arrow} /> */}
      </div>
      <div
        className={classes.animatedWrapper}
        ref={$animatedWrapper}
      >
        <div
          ref={$measureRef}
          className={classes.accordionContent}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default SingleAccordion
